import { routes } from "consts";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getApiErrorMessage, useToaster } from "utils";

import { usePlaceTagsOptions } from "api/hooks";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { PlaceForm, PlaceFormValues } from "./PlaceForm/PlaceForm";
import { usePlace } from "api/hooks/usePlace";
import { placesApi } from "api";

export const PlaceEditPage = (): JSX.Element | null => {
  const { placeId } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { loading, data } = usePlace(Number(placeId));
  const { loading: loadingTags, options: tags } = usePlaceTagsOptions();

  if (loading || loadingTags || data === null) return null;

  const breadcrumbs = [{ title: "Miejsca", path: routes.PLACES }, { title: data.name }];

  const onSubmit = async (data: PlaceFormValues) => {
    try {
      await placesApi.update(Number(placeId), data);
      navigate(routes.PLACES);
      showSuccess("Miejsce zostało zaktualizowane");
    } catch (error) {
      showError(getApiErrorMessage(error, "Nie udało się zaktualizować miejsca"));
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj miejsce" />
      <PlaceForm tags={tags} onSubmit={onSubmit} data={data} />
    </PageMain>
  );
};
